import { headerTheme } from "@configs/themeGenerator";
import { IStackItemStyles, IStackStyles, IStackTokens, mergeStyleSets, Stack, ThemeProvider } from "@fluentui/react";
import { useAppStore } from "@store/index";
import React from "react";

const stackStyles: IStackStyles = {
  root: {
    padding: 10,
    width: "100%",
  },
};

export const Header = () => {
  const { accountStore } = useAppStore();
  const headerStyles = mergeStyleSets({
    currentUser: {
      fontWeight: 600,
    },
  });
  return (
    <ThemeProvider theme={headerTheme} applyTo="element">
      <Stack horizontal styles={stackStyles}>
        <Stack.Item disableShrink align="center">
          <img src="/icons/rocketta_icon.svg" alt="*" />
        </Stack.Item>
        <Stack.Item grow={1}> </Stack.Item>
        <Stack.Item disableShrink align="center">
          <h3 className={headerStyles.currentUser}>{accountStore.currentUser.name}</h3>
        </Stack.Item>
      </Stack>
    </ThemeProvider>
  );
};
